import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
// This must be Supabase's public anon/publishable key. Never use a service-role
// key in browser code: React embeds every REACT_APP_* value in the JS bundle.
const supabaseKey = process.env.REACT_APP_SUPABASE_KEY;

if (!supabaseUrl || !supabaseKey) {
    throw new Error('Supabase public URL and anon/publishable key are required.');
}

export const supabase = createClient(supabaseUrl, supabaseKey);
